import Vue from 'vue';
import { extend, configure, ValidationObserver, ValidationProvider } from "vee-validate";
import { required, email, min, numeric, regex, min_value } from "vee-validate/dist/rules";
import i18n from "../localization/i18n";

configure({
  defaultMessage: (field, values) => {
    if(values._rule_ === 'required')
      return i18n.tc('fields.required');
    // override the field name.
    let translation = i18n.t(field);
    if(translation === field) {
      translation = i18n.t('fields.' + field);
    }
    values._field_ = translation;

    return i18n.t(`validation.${values._rule_}`, values);
  }
});
// Install required rule and message.
extend("required", required);
extend("email", email);
extend("min", min);
extend("min_value", min_value);
extend("numeric", numeric);
extend("regex", regex);

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);


